module.exports = __webpack_public_path__ + "img/coupon_disabled.6f3a1995.png";